let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("34awq")).then(() => parcelRequire('7nDDl'));